import { AxiosResponse } from 'axios'
import { API } from '../config'
import { DashboardDto } from 'src/dto/dashboard.dto'

export class DashboardService {
  public async getDashboardInfo(farmId: string): Promise<AxiosResponse<DashboardDto[]>> {
    return await API.get(`dash/${farmId}`)
  }
}
